// extracted by mini-css-extract-plugin
module.exports = {"container":"badge-grid_container__MuLfV","box":"badge-grid_box__aFV5U","row":"badge-grid_row__RFl6a"};